import { render, staticRenderFns } from "./MarketplaceWeekly.vue?vue&type=template&id=6bf90ba4&scoped=true"
import script from "./MarketplaceWeekly.vue?vue&type=script&lang=js"
export * from "./MarketplaceWeekly.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceWeekly.vue?vue&type=style&index=0&id=6bf90ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf90ba4",
  null
  
)

export default component.exports